/* KINDERSTIMME™ · SAT Akademie · Interaktives Deck
 * Quelle: Originalfolien Nenad Vladović · Korrekturen integriert
 * Stand: 10 Folien (komplett) */
export const kinderstimmeSlides = [
  {
    num: 1,
    type: "cover",
    title: "KINDERSTIMME™",
    subtitle: "Jede Stimme zählt. Jedes Kind zählt.",
    intro:
      "Jedes Kind trägt ein einzigartiges Licht in sich. Unsere Aufgabe ist es, dieses Licht zu schützen, zu nähren und zum Leuchten zu bringen. Kinder sind nicht die Zukunft. Sie sind das Jetzt. Sie sind das Wunder. Sie sind unser größtes Geschenk.",
    tagline: "HERZ · VERSTAND · SEELE · KRAFT · ALLE",
    closing:
      "Wir geben Kindern eine Stimme. Wir geben Kindern ein Herz. Wir geben Kindern eine Zukunft.",
    side: {
      title: "Für unsere Kinder · Für das Leben · Für die Welt",
      items: [
        "Kinder haben das Recht, glücklich zu sein.",
        "Gehört zu werden. Sich sicher zu fühlen.",
        "Sie haben das Recht, sie selbst zu sein.",
        "Und sie haben das Recht auf eine Zukunft, in der sie ihr volles Potenzial entfalten können.",
      ],
    },
  },

  {
    num: 2,
    type: "content",
    layout: "grid",
    kicker: "WARUM KINDERSTIMME™?",
    title: "Kinder sind unsere Zukunft.",
    subtitle:
      "Doch Zukunft entsteht nicht von selbst — sie entsteht in den Herzen der Kinder, in ihren Erfahrungen, in ihrer Kindheit.",
    intro:
      "KINDERSTIMME gibt Kindern eine Stimme. Sie stärkt Kinder für das Leben. Sie schenkt Kindern Hoffnung. Sie begleitet Kinder auf ihrem Weg. Sie verändert die Welt — von innen heraus.",
    bullets: [
      { h: "Steigende Belastungen", t: "Stress, Leistungsdruck, reizüberflutete Medien, Unsicherheit und Angst prägen viele Kinder heute." },
      { h: "Emotionale Verletzungen", t: "Viele Kinder erleben Vernachlässigung, Streit, Trennung oder Mobbing — und leiden still." },
      { h: "Verlust von Selbstwert", t: "Kinder, die nicht gesehen und gehört werden, zweifeln an sich — und verlieren den Glauben an sich selbst." },
      { h: "Unentdecktes Potenzial", t: "Jedes Kind trägt einzigartige Talente in sich. Doch ohne Unterstützung bleiben diese oft verborgen." },
      { h: "Unsere Verantwortung", t: "Eine gesunde Kindheit ist kein Luxus — sie ist das Fundament für eine bessere Welt." },
    ],
    mantra:
      "Die größte Aufgabe unserer Zeit ist es, die Herzen unserer Kinder zu schützen und zu stärken.",
    cta: {
      title: "Kinderstimme ist mehr als ein Projekt",
      sub: "Es ist eine Bewegung für eine kindgerechte Welt. Für heute. Für morgen. Für immer.",
    },
  },

  {
    num: 3,
    type: "content",
    layout: "grid",
    kicker: "DIE WELT EINES KINDES",
    title: "Voller Wunder, Entdeckungen und Möglichkeiten.",
    subtitle:
      "Kinder erleben Intensität, Ehrlichkeit und Staunen. Jede Erfahrung prägt. Jeder Moment bleibt. Kinder leben im Hier und Jetzt — offen, neugierig und mit einem großen Herzen.",
    intro:
      "Ihre Welt ist kostbar. Unsere Aufgabe ist es, sie zu bewahren, zu nähren und zu schützen.",
    bullets: [
      { h: "Staunen", t: "Kinder sind von Natur aus neugierig und begeistert. Sie wollen verstehen, entdecken und lernen." },
      { h: "Vertrauen", t: "Sie vertrauen auf die Erwachsenen in ihrem Leben und orientieren sich an Liebe und Halt." },
      { h: "Freude", t: "Kleine Dinge machen sie glücklich. Sie lachen ehrlich, lieben bedingungslos und leben im Moment." },
      { h: "Fantasie", t: "Kinder haben eine reiche Vorstellungskraft. Sie träumen, erschaffen und gestalten." },
      { h: "Verbundenheit", t: "Kinder brauchen echte Beziehungen, Nähe und das Gefühl, dazuzugehören." },
      { h: "Entwicklung", t: "Jeder Tag ist ein Schritt auf ihrem Weg — voller Potenzial, das entdeckt und gefördert werden will." },
    ],
    mantra:
      "Kinder sehen nicht die Welt, wie sie ist. Sie sehen die Welt, wie sie sein könnte. Und genau darin liegt unsere Hoffnung.",
    cta: {
      title: "Die Welt eines Kindes ist zart und kraftvoll zugleich",
      sub: "Lass uns ihre Welt verstehen. Ihre Träume achten. Ihre Herzen stärken. Lass uns für sie da sein. Heute. Morgen. Für immer.",
    },
  },

  {
    num: 4,
    type: "content",
    layout: "grid",
    kicker: "DIE HERAUSFORDERUNGEN VON KINDERN HEUTE",
    title: "Kinder wachsen in einer Welt auf, die sich schneller verändert als je zuvor.",
    subtitle:
      "Viele äußere Einflüsse belasten ihre Entwicklung, ihr Wohlbefinden und ihre Kindheit.",
    intro:
      "Unsere Aufgabe ist es, diese Herausforderungen zu erkennen, zu verstehen und gemeinsam Lösungen zu schaffen.",
    bullets: [
      { h: "Digitaler Druck", t: "Zu viel Bildschirmzeit, ständige Reizüberflutung und der Vergleich in sozialen Medien." },
      { h: "Mentale Belastung", t: "Stress, Leistungsdruck und hohe Erwartungen führen zu Ängsten, Erschöpfung und Selbstzweifeln." },
      { h: "Familiäre Herausforderungen", t: "Trennung, Streit, fehlende Zeit oder Erziehung mit Druck beeinträchtigen Sicherheit und Vertrauen." },
      { h: "Mobbing & Ausgrenzung", t: "Viele Kinder fühlen sich nicht akzeptiert oder sicher — weder in der Schule noch im Alltag." },
      { h: "Verlust von Kindheit", t: "Zu wenig Zeit für Spiel, Natur, Kreativität und Freunde — Kindheit wird oft überladen und verplant." },
      { h: "Zuviel Unsicherheit", t: "Kriege, Klimakrise und eine ungewisse Zukunft verunsichern Kinder tief." },
    ],
    mantra:
      "Nicht die Kinder müssen sich der Welt anpassen. Die Welt muss sich der Kindheit anpassen.",
    cta: {
      title: "Jedes Kind braucht Menschen, die hinsehen · die zuhören · die handeln",
      sub: "Wir können Kindern helfen, stark zu werden. Wir können Kindern zeigen, dass sie wichtig sind. Wir können Kindern eine Zukunft voller Hoffnung schenken.",
    },
  },

  {
    num: 5,
    type: "content",
    layout: "grid",
    kicker: "WAS KINDER WIRKLICH BRAUCHEN",
    title: "Kinder brauchen nicht viel. Aber sie brauchen das Richtige.",
    subtitle:
      "Was Kinder wirklich brauchen, ist die Basis für ein gesundes, glückliches und erfülltes Leben.",
    intro:
      "Unsere Aufgabe ist es, ihnen genau das zu geben — jeden Tag, in kleinen und großen Momenten.",
    bullets: [
      { h: "Liebe", t: "Bedingungslose Liebe gibt Kindern Sicherheit und lässt sie spüren: Ich bin wertvoll." },
      { h: "Sicherheit", t: "Ein stabiles Umfeld, feste Rituale und verlässliche Menschen geben Halt und Vertrauen." },
      { h: "Zeit und Zuwendung", t: "Kinder brauchen echte Aufmerksamkeit und Zeit — nicht nebenbei, sondern mit dem Herzen." },
      { h: "Zuhören", t: "Wer Kindern zuhört, nimmt sie ernst und stärkt ihr Selbstvertrauen und ihr inneres Wachstum." },
      { h: "Wertschätzung", t: "Anerkennung und Lob bestärken Kinder und zeigen ihnen: Du bist genau richtig." },
      { h: "Freiheit & Grenzen", t: "Kinder brauchen Raum, um sich zu entfalten, und klare Grenzen, die sie schützen." },
      { h: "Vertrauen", t: "Glaube an ihre Fähigkeiten gibt Kindern Mut, an sich zu glauben und ihren eigenen Weg zu gehen." },
    ],
    mantra:
      "Kinder brauchen keine perfekten Eltern. Sie brauchen liebevolle, präsente Menschen, die für sie da sind.",
    cta: {
      title: "Wenn wir Kindern geben, was sie wirklich brauchen",
      sub: "Können sie zu dem werden, was in ihnen liegt. Lass uns gemeinsam Kindern die Liebe, Sicherheit und Unterstützung geben, die sie verdienen — heute, morgen und für immer.",
    },
  },

  {
    num: 6,
    type: "content",
    layout: "grid",
    kicker: "UNSER SAT ANSATZ",
    title: "Wir glauben an jedes Kind.",
    subtitle:
      "Wir sehen jedes Kind als einzigartig, wertvoll und voller Potenzial. Unser Ansatz ist ganzheitlich, liebevoll und stärkenorientiert.",
    intro:
      "Wir begleiten Kinder dabei, sich selbst zu entdecken, zu entfalten und mutig ihren eigenen Weg zu gehen. Unser Ziel ist es, Kinder stark zu machen — von innen heraus, für ein glückliches und erfülltes Leben.",
    bullets: [
      { h: "Ganzheitlich", t: "Wir fördern Körper, Geist, Seele und Herz — für eine gesunde und ganzheitliche Entwicklung." },
      { h: "Stärkenorientiert", t: "Wir entdecken und fördern die Talente, Begabungen und Interessen jedes Kindes. Jedes Kind ist besonders." },
      { h: "Liebevoll & Achtsam", t: "Wir begegnen Kindern mit Respekt, Empathie und Wertschätzung. So entsteht Vertrauen und Sicherheit." },
      { h: "Mutmachend", t: "Wir ermutigen Kinder, über sich hinauszuwachsen, neue Wege zu gehen und an sich zu glauben." },
      { h: "Zukunftsorientiert", t: "Wir bereiten Kinder auf eine Welt vor, in der sie verantwortungsvoll, kreativ und mit Herz handeln." },
    ],
    mantra:
      "Wir stärken Kinder. Wir inspirieren Kinder. Wir begleiten Kinder. Wir glauben an Kinder. Wir fördern Kinder. Wir vertrauen Kindern.",
    cta: {
      title: "Das ist unser SAT Ansatz",
      sub: "Ganzheitlich · Stärkenorientiert · Liebevoll · Mutmachend · Zukunftsorientiert.",
    },
  },

  {
    num: 7,
    type: "content",
    layout: "grid",
    kicker: "UNSERE ANGEBOTE",
    title: "Vielfältig. Ganzheitlich. Praxisnah.",
    subtitle:
      "Wir bieten vielfältige, ganzheitliche und praxisnahe Angebote für Kinder — abgestimmt auf ihre Bedürfnisse, ihre Entwicklung und ihre Lebenswelt.",
    intro:
      "Unsere Angebote stärken Kinder auf allen Ebenen — emotional, mental, sozial und kreativ. Für mehr Selbstvertrauen, innere Stärke und Freude am Leben.",
    bullets: [
      { h: "Selbstwert & Selbstvertrauen", t: "Kinder stärken ihr Selbstbewusstsein und erkennen, wie wertvoll und einzigartig sie sind." },
      { h: "Emotionale Stärke", t: "Kinder lernen, ihre Gefühle zu verstehen, auszudrücken und positiv mit ihnen umzugehen." },
      { h: "Soziale Kompetenz & Freundschaft", t: "Kinder entwickeln Empathie, Respekt und Teamgeist für ein harmonisches Miteinander." },
      { h: "Kreativität & Talententfaltung", t: "Kinder entdecken und entfalten ihre Talente in einem Umfeld voller Inspiration." },
      { h: "Resilienz & Innere Stärke", t: "Kinder werden stark fürs Leben — sie lernen, mit Herausforderungen umzugehen und daran zu wachsen." },
      { h: "Achtsamkeit & Entspannung", t: "Kinder finden Ruhe, lernen achtsam zu sein und entwickeln innere Balance und Konzentration." },
      { h: "Zukunft & Potenzial", t: "Kinder werden ermutigt, grosse Träume zu haben und ihren eigenen Weg voller Freude und Vertrauen zu gehen." },
    ],
    mantra:
      "Unsere Angebote sind vielfältig, ganzheitlich und liebevoll gestaltet. Wir begleiten Kinder — mit Herz, Verstand und Stärke.",
    cta: {
      title: "Für ein glückliches, erfülltes und selbstbestimmtes Leben",
      sub: "Emotional · Mental · Sozial · Kreativ.",
    },
  },

  {
    num: 8,
    type: "content",
    layout: "grid",
    kicker: "UNSERE METHODEN",
    title: "Kinder lernen und wachsen auf vielfältige Weise.",
    subtitle:
      "Deshalb nutzen wir Methoden, die ihre Welt verstehen, sie abholen und sie in ihrer Entwicklung ganzheitlich fördern.",
    intro:
      "Unsere Methoden sind kindgerecht, wissenschaftlich fundiert und mit viel Herz in die Praxis umgesetzt.",
    bullets: [
      { h: "Wertebasierte Pädagogik", t: "Wir vermitteln Werte erlebbar und geben Kindern Orientierung, Respekt und Empathie im Alltag." },
      { h: "Gesprächskreise", t: "In geschützten Runden können Kinder sprechen, zuhören und verstanden werden. Ihre Stimme zählt." },
      { h: "Kreative Methoden", t: "Malen, basteln, schreiben, Rollen spielen — Kinder drücken sich kreativ aus und entdecken ihre innere Welt." },
      { h: "Achtsamkeit & Entspannung", t: "Kindgerechte Achtsamkeitsübungen, Fantasiereisen und Atemtechniken fördern Ruhe, Fokus und innere Balance." },
      { h: "Kompetenztraining", t: "Soziale Kompetenzen, Konfliktlösung und Selbstbehauptung stärken Kinder für ein gelingendes Miteinander." },
      { h: "Geschichten & Vorbilder", t: "Inspirierende Geschichten und positive Vorbilder zeigen Kindern, was alles möglich ist und ermutigen sie." },
      { h: "Projekt- & Erlebnislernen", t: "Durch Projekte und Erlebnisse in der Praxis wenden Kinder ihr Wissen an und wachsen über sich hinaus." },
    ],
    mantra:
      "Wir nutzen Methoden, die Kinder bewegen, die ihre Stärken fördern und ihre Freude am Leben entzünden.",
    cta: {
      title: "So entwickeln sie sich zu selbstbewussten, starken und glücklichen Menschen",
      sub: "Kindgerecht · Wissenschaftlich fundiert · Praxisnah · Mit Herz.",
    },
  },

  {
    num: 9,
    type: "content",
    layout: "grid",
    kicker: "UNSERE WERTE",
    title: "Werte sind unser innerer Kompass.",
    subtitle:
      "Sie zeigen uns, was wirklich zählt, und leiten unser Handeln — jeden Tag, in jeder Begegnung.",
    intro:
      "Unsere Werte sind das Fundament, auf dem Kinder stark, frei und glücklich heranwachsen. Wir leben sie. Wir teilen sie. Wir stärken sie.",
    bullets: [
      { h: "Respekt", t: "Wir begegnen jedem mit Wertschätzung und Achtung — unabhängig von Herkunft, Meinung oder Fähigkeiten." },
      { h: "Vertrauen", t: "Wir schaffen ein sicheres Umfeld, in dem Kinder sich wohlfühlen, Fehler machen und daraus lernen dürfen." },
      { h: "Empathie", t: "Wir hören zu, fühlen mit und verstehen die Perspektive anderer — so entsteht echte Verbindung." },
      { h: "Verantwortung", t: "Wir übernehmen Verantwortung für uns selbst, für andere und für unsere gemeinsame Zukunft." },
      { h: "Zusammenhalt", t: "Wir halten zusammen, unterstützen einander und feiern Unterschiede als Stärke." },
      { h: "Neugier", t: "Wir sind offen für Neues, stellen Fragen und entdecken die Welt mit Freude und Begeisterung." },
      { h: "Mut", t: "Wir haben den Mut, neue Wege zu gehen, für uns einzustehen und Veränderung zu wagen." },
      { h: "Nachhaltigkeit", t: "Wir denken an morgen und handeln heute verantwortungsvoll — für uns, für andere und für unseren Planeten." },
    ],
    mantra:
      "Unsere Werte sind mehr als Worte — sie sind unser Handeln. Wir leben sie. Wir teilen sie. Wir stärken sie.",
    cta: {
      title: "Gemeinsam gestalten wir eine Welt",
      sub: "in der Kinder aufblühen und ihre Träume verwirklichen können.",
    },
  },

  {
    num: 10,
    type: "content",
    layout: "grid",
    kicker: "WIRKUNG, DIE BLEIBT",
    title: "Was wir Kindern heute geben, prägt die Welt von morgen.",
    subtitle:
      "Unsere Arbeit ist eine Investition in die Zukunft — in Menschlichkeit, Kreativität und Verantwortung.",
    intro:
      "Wir wollen Kindern nicht nur Wissen mitgeben, sondern Werte, Selbstvertrauen und die Kraft, ihre Welt aktiv und positiv zu gestalten.",
    bullets: [
      { h: "Stärkung des Selbstvertrauens", t: "Kinder erkennen ihren Wert und finden ihren Platz in der Welt." },
      { h: "Entfaltung des Potenzials", t: "Kinder entdecken ihre Talente und gehen mutig ihren eigenen Weg." },
      { h: "Harmonisches Miteinander", t: "Kinder lernen Respekt, Empathie und Zusammenhalt — als Basis für ein gutes Leben." },
      { h: "Positive Veränderung", t: "Kinder wirken in ihrer Familie, ihrem Umfeld und ihrer Gemeinschaft — mit Herz und Haltung." },
      { h: "Inspiration für andere", t: "Kinder werden zu Vorbildern und tragen ihre Werte in die Welt hinaus." },
      { h: "Ein Erbe für die Zukunft", t: "Kinder von heute gestalten die Welt von morgen — mit Bewusstsein und Verantwortung." },
    ],
    mantra:
      "Wenn wir Kinder heute stärken, gestalten wir eine bessere Welt für morgen.",
    cta: {
      title: "Gemeinsam für eine Zukunft",
      sub: "in der Kinder gesehen, gehört und geliebt werden.",
    },
  },
];

export default kinderstimmeSlides;
